function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.91 15.724a.887.887 0 01-1.287 0 .965.965 0 010-1.331l5.279-5.46H.909C.407 8.933 0 8.512 0 7.992s.407-.94.909-.94h15.977l-5.263-5.445a.965.965 0 010-1.332.887.887 0 011.286.001l6.824 7.059a.964.964 0 010 1.33l-6.824 7.059z",
  fill: "#596168",
  fillRule: "evenodd"
});

var SvgArrow = function SvgArrow(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 16
  }, props), _ref);
};

export default SvgArrow;